module.exports = __webpack_public_path__ + "img/cannon20_bg.08a73714.png";